// ✅ REPLACE your BookingApi with this updated version:

import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const BookingApi = createApi({
  reducerPath: "BookingApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["BOOKINGAPI"],
  endpoints: (build) => ({
    getAllBookings: build.query({
      query: ({ 
        page = 1, 
        search = "", 
        bookingType = "", 
        status = "", 
        botId = "",
        startDate = "",
        endDate = "",
        limit = 10 
      }) => ({
        url: `/bookings?page=${page}&search=${search}&bookingType=${bookingType}&status=${status}&botId=${botId}&startDate=${startDate}&endDate=${endDate}&limit=${limit}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BOOKINGAPI"],
    }),

    getBookingById: build.query({
      query: (id) => ({
        url: `/bookings/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BOOKINGAPI"],
    }),

    getBookingStats: build.query({
      query: ({ startDate = "", endDate = "", botId = "" }) => ({
        url: `/bookings/stats?startDate=${startDate}&endDate=${endDate}&botId=${botId}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BOOKINGAPI"],
    }),

    getUpcomingBookings: build.query({
      query: ({ limit = 10 }) => ({
        url: `/bookings/upcoming?limit=${limit}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BOOKINGAPI"],
    }),

    // ✅ NEW: Get bookings by phone
    getBookingsByPhone: build.query({
      query: (phone) => ({
        url: `/bookings/phone/${phone}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BOOKINGAPI"],
    }),

    // ✅ IMPROVED: Get available slots with bot configuration
    getAvailableSlots: build.query({
      query: ({ date, bookingType = "", botId }) => ({
        url: `/bookings/available-slots?date=${date}&bookingType=${bookingType}&botId=${botId}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BOOKINGAPI"],
    }),

    createBooking: build.mutation({
      query: (data) => ({
        url: `/bookings`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BOOKINGAPI"],
    }),

    updateBooking: build.mutation({
      query: ({ id, ...data }) => ({
        url: `/bookings/${id}`,
        method: "PUT",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BOOKINGAPI"],
    }),

    updateBookingStatus: build.mutation({
      query: ({ id, status }) => ({
        url: `/bookings/${id}/status`,
        method: "PATCH",
        body: { status },
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BOOKINGAPI"],
    }),

    // ✅ NEW: Cancel booking with reason
    cancelBooking: build.mutation({
      query: ({ id, reason }) => ({
        url: `/bookings/${id}/cancel`,
        method: "PATCH",
        body: { reason },
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BOOKINGAPI"],
    }),

    // ✅ NEW: Reschedule booking
    rescheduleBooking: build.mutation({
      query: ({ id, bookingDate, bookingTime }) => ({
        url: `/bookings/${id}/reschedule`,
        method: "PATCH",
        body: { bookingDate, bookingTime },
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BOOKINGAPI"],
    }),

    deleteBooking: build.mutation({
      query: (id) => ({
        url: `/bookings/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BOOKINGAPI"],
    }),
  }),
});

export const {
  useGetAllBookingsQuery,
  useGetBookingByIdQuery,
  useGetBookingStatsQuery,
  useGetUpcomingBookingsQuery,
  useGetBookingsByPhoneQuery,
  useGetAvailableSlotsQuery,
  useCreateBookingMutation,
  useUpdateBookingMutation,
  useUpdateBookingStatusMutation,
  useCancelBookingMutation,
  useRescheduleBookingMutation,
  useDeleteBookingMutation,
  useLazyGetAllBookingsQuery,
  useLazyGetBookingByIdQuery,
  useLazyGetBookingsByPhoneQuery,
  useLazyGetAvailableSlotsQuery,
} = BookingApi;